<template>
    <div class="container">
        
        <div class="new-page-form add-trips">
            <div v-if="user && !user.isAnonymous">Logged in as {{user.displayName}} <a @click="signOut">Sign out</a></div>
            
                <h1 class="title is-3" id="share-header" style="text-align:center">Add to the Directory</h1>
                <div class="" style="text-align:center; font-size: 1.1em">
                    <span v-bind:style="$getTotals()._posts ? 'visibility:visible' : 'visibility:hidden'">
                        <strong class="">Join us!  {{totals._posts}} posts from {{totals._sites}} riders in {{totals._countries}} countries, and growing fast. </strong></span></div>
                
                <div class="section card top-margin" style="padding: 30px 30px" v-if="!this.activeStep > 0 && showInstructions"> 
                    
                    <h2 class="title is-5"><strong>How it works: </strong></h2>
                    <span><strong>1) </strong>Enter the URL of a blog post about a bike tour or bikepacking trip.</span><br>
                    <span><strong>2) </strong>Select the place, style, and a few other details to describe the ride.</span><br>
                    <span><strong>3) </strong>Add optional fun details to help other cyclists discover new routes.</span><br>
                    <span><strong>4) </strong>We'll review the link to make sure it's actually a bike travel blog (no spam allowed) and then add it to the BSB directory, where it can inspire and inform other bike travelers. Hooray!</span><br><br>
                    <span>Still have questions? <a href="/about" target="_blank">Read more here.</a></span><br><br>
                    <span @click="hideInstructions()" class="hide-instructions hint"><b-icon class=''  icon="times" size="is-small"></b-icon>Hide these instructions</span>
                </div>
                
                <div class="steps" style="">
                <b-steps
                    v-model="activeStep"
                    type="is-primary"
                    :animated="true"
                    :rounded="true"
                    
                    :has-navigation="false"
                   
                    label-position="bottom"
                    mobile-mode="compact">
                    <b-step-item step="1" label="Start" :clickable="false">
                        <!-- <h1 class="title top-margin">Post URL</h1> -->
                        <div class="top-margin">
                            <!-- <h3 class="title is-3"  style="">Step 1 of 2</h3> -->
                            <strong>Enter URL of a single post: </strong>
                            <div class="hint">Yes, a single post, not the home or archive page please. The magic of BSB is that users can search for individual posts. Questions? <a href="/about" target="_blank">More info here.</a></div>
                            <!-- <b-tooltip
                                label="NOT the home page or an archive page please. The magic of BSB is that users can search for individual posts by place, route, and more."
                                multilined type="is-light" size="is-large">
                                <button class="button is-light tooltip-trigger" type="button">
                                    <b-icon class="tooltip-icon" pack="fas"   icon="question-circle"  size="is-small"> </b-icon>
                                </button>
                            </b-tooltip> -->

                            <b-field>

                                <b-input ref="urlinput"  placeholder="https://example.com/post-1" type="url" v-model="url" size="is-medium" :disabled="(checkingPage || (editMode && existingPageData))"></b-input>
                            </b-field>  

                            <b-message type="is-danger" class="top-margin combined-error" v-if="submitErrorMsg != ''">{{submitErrorMsg}}</b-message>

                            <b-button class='is-primary is-medium top-margin'  
                                v-if="(!(checkingPage || (editMode && existingPageData)) && !(alreadyExists && !editMode) )"
                                id="next-step-btn"
                                v-bind:class="(checkingPage && tempPageDoc && tempPageDoc.metadata_status === undefined) || (checkingPage && tempPageDoc && tempPageDoc.metadata_status == 'fetching') ? 'is-loading' : ''" 
                                @click="checkPage" style="min-width:160px">Next Step</b-button>

                            <b-message class="top-margin" type="is-warning" v-if="alreadyExists  && !editMode"><span>That page is already in the directory. You can edit it, or cancel and try a different page.</span>
                                <div style="display:block; padding-top:10px">
                                <b-button class='is-primary' @click="editExisting">Edit Page</b-button>
                                <b-button class='' @click="resetState()">Cancel</b-button>
                                </div>
                            </b-message>                  
                        </div>
                    </b-step-item>

                    <b-step-item step="2" label="Ride"  type="is-primary">

                        <b-message class="top-margin">
                            <div class=''><strong>{{(editMode ? 'You are editing the entry for:' : 'You are submitting an entry for:') }}</strong></div>
                            <a :href="url" target="_blank">{{(editMode && existingPageData.title) ? existingPageData.title : (tempPageDoc && tempPageDoc.title ? tempPageDoc.title : url )}}</a>
                        </b-message>
                        
                        <h1 class="title top-margin">About the Ride</h1>
                        <p class="has-text-primary title is-6">Tell us about this bike trip! These details help other cyclists find trips that match their interests.</p>

                        
                        
                    <!-- COUNTRIES -->
                    <CustomTagInput class="top-margin" 
                        v-bind:label = "'Countries (required)'" 
                        v-bind:size = "'is-medium'" 
                        v-bind:placeholder = "'Type to choose one or more'" 
                        v-bind:allData = "countryArray"
                        v-bind:field = "'name'"
                        v-bind:allowNew = "false"
                        v-bind:openOnFocus = "false"
                        v-bind:autocomplete = "true"
                        v-bind:type = "'is-success'"
                        ref = "country-tags"
                        @changed = "handleCountryChange"
                    />

                    <!-- REGION -->
                    <CustomTagInput class="top-margin" v-bind:class="countryRegions.length == 0 ? 'hidden' : ''"

                        v-bind:label = "'Regions or States (optional)'" 
                        v-bind:size = "'is-medium'" 
                        v-bind:placeholder = "'Type to choose one or more'" 
                        v-bind:allData = "countryRegions"
                        v-bind:allowNew = "false"
                        v-bind:type = "'is-success'"
                        ref = "region-tags"
                    />


                     <!-- STYLE -->
                    <div class="top-margin">
                        <strong>Style (required)</strong>
                        <div class="hint">Touring: think panniers, pavement or gravel, more populated areas. Bikepacking: think seat bag and minimalist gear, dirt and gravel, remote areas. Yes, we know there is overlap. You can choose both if you really want to.</div>

                        <!-- <div class="hint">Choose all that apply to a significant portion of the ride described in this particular post.</div> -->
                        
                        <b-field class='taginput wrap'>
                            <!-- <div class="block"> -->
                                <b-checkbox-button v-model="selectedStyles"
                                    native-value="touring">
                                    <span>Touring</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedStyles"
                                    native-value="bikepacking">
                                    <span>Bikepacking</span>
                                </b-checkbox-button>
                               
                        </b-field>
                    </div>


                    <!-- ROUTE -->
                    <div class="top-margin">
                        <strong>Route (optional)</strong>
                        <div class="hint">Does this ride follow an established route? Type to search, or type and then <strong>press enter</strong> to add a missing route (please try to find an existing route before adding a new one).</div>
                        <CustomTagInput 
                            v-bind:label = "''" 
                            v-bind:size = "'is-medium'" 
                            v-bind:placeholder = "'Type to choose one or more'" 
                            v-bind:allData = "routes"
                            v-bind:approvedData = "approvedRoutes"
                            v-bind:allowNew = "true"
                            v-bind:type = "'is-success'"
                            ref = "route-tags"
                        />
                    </div>
                   
                    <!-- SURFACES -->
                    <div class="top-margin">
                        <strong>Roads and Trails (optional)</strong>
                        <div class="hint">Choose all that apply to a significant portion of the ride described in this particular post.</div>
                        <b-field class='taginput wrap'>
                            <!-- <div class="block"> -->
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="pavement">
                                    <span>Pavement</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="gravel">
                                    <span>Gravel</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="dirt">
                                    <span>Dirt</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="singletrack">
                                    <span>Singletrack</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="bike paths">
                                    <span>Bike Paths</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="low traffic">
                                    <span>Low Traffic</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="hilly">
                                    <span>Hilly</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedSurfaces"
                                    native-value="flat">
                                    <span>Flat</span>
                                </b-checkbox-button>
                            
                        </b-field>
                    </div>

                     <!-- YEAR -->
                    <div class="top-margin">
                        <strong>Year (optional)</strong>
                        <!-- <div class="hint">Help people find recent journals.</div> -->
                        <b-field label="">
                            <b-input class='year-input' placeholder="YYYY" type="number" v-model="year" size="is-medium" width="200"></b-input>
                        </b-field>
                    </div>

                    <b-message type="is-danger" class="top-margin combined-error" v-if="submitErrorMsg != ''">{{submitErrorMsg}}</b-message>

                    <div class="submit-nav-buttons" >
                        
                        <b-button class='is-primary is-medium next' @click="toStep3()">Next Step</b-button>
                        <b-button class='cancel is-medium' style="float:right" @click="resetState()">Start Over</b-button>
                    </div>

                    </b-step-item>

                    <b-step-item step="3" label="Bonus" >

                        <b-message class="top-margin">
                            <div class=''><strong>{{(editMode ? 'You are editing the entry for:' : 'You are submitting an entry for:') }}</strong></div>
                            <span>{{(editMode && existingPageData.title) ? existingPageData.title : (tempPageDoc && tempPageDoc.title ? tempPageDoc.title : url )}}</span>
                        </b-message>

                        <h1 class="title top-margin" id="step-3-title">Extra Goodies</h1>
                        <p class="has-text-primary title is-6">Tell us more about this ride to help other cyclists find bike routes that match their passions. These are all optional.</p>
                        
                        <!-- MOODS -->
                    <div class="top-margin">
                        <strong>Special Features (optional)</strong>
                        <p class="hint">What made this ride stand out? Choose as many as you want. </p>
 
                   
                        <b-field class='taginput wrap'>
                            <!-- <div class="block"> -->
                            <b-checkbox-button v-for="feature in allFeatures" v-bind:key="feature" v-model="selectedFeatures"
                                :native-value="feature">
                                <span>{{feature}}</span>
                            </b-checkbox-button>
                        
                        </b-field>
                        
                    </div>

                     <!-- RIDERS -->
                     <div class="top-margin">
                        <strong>About Rider and Bike (optional)</strong>
                        <div class="hint">
                            <span>Help people find journals from a diverse community of riders. Type to search, or type and then <strong>press enter</strong> to add your own. Please try to find an existing tag before adding a new one.
                                Examples: solo female, person of color, with kids, over 65, tandem, Rohloff, fat bike, etc.
                            </span>
                          
                        </div>
                        <CustomTagInput 
                            v-bind:label = "''" 
                            v-bind:size = "'is-medium'" 
                            v-bind:placeholder = "'Type to choose one or more'" 
                            v-bind:allData = "riderTags"
                            v-bind:approvedData = "approvedRiderTags"
                            v-bind:allowNew = "true"
                            v-bind:openOnFocus = "true"
                            v-bind:type = "'is-success'"
                            ref = "rider-tags"
                        />
                     </div>
                    <!-- <pre>Cookie tags: {{getCookieArray('ridertags')}}</pre> -->
                    <!-- <pre>{{riderTags}}</pre> -->
                    
                    <!-- OTHER GOODIES -->
                     <div class="top-margin">
                        <strong>Extra Goodies (optional)</strong>
                        <div class="hint"><span>Choose any that apply.</span> </div>
                        <b-field class='taginput wrap'>
                            <b-checkbox-button v-model="selectedExtras"
                                native-value="short">
                                <span>Short Trip (2-5 days)</span>
                            </b-checkbox-button>
                            <b-checkbox-button v-model="selectedExtras"
                                native-value="map">
                                <span>Has Map</span>
                            </b-checkbox-button>
                            <b-checkbox-button v-model="selectedExtras"
                                native-value="video">
                                <span>Has Video</span>
                            </b-checkbox-button>
                            <b-checkbox-button v-model="selectedExtras"
                                native-value="podcast">
                                <span>Podcast</span>
                            </b-checkbox-button>
                            
                        </b-field>
                    </div>

                    <div class="top-margin">
                        <strong>Receive Confirmation (optional)</strong>
                        <div class="hint"><span>Totally optional, but if you'd like to be emailed a confirmation when this post is approved, enter your address here. It will NOT be published.</span> </div>
                         <b-field>
                            <b-input ref="urlinput" style="width:350px;" placeholder="email address" type="email" v-model="email" size="is-medium" ></b-input>
                        </b-field>

                    </div>
                    <b-message type="is-danger" class="top-margin combined-error" v-if="submitErrorMsg != ''">{{submitErrorMsg}}</b-message>
                    <div class="submit-nav-buttons" >
                        <b-button class='is-primary is-medium next' @click="submitPage()">Submit!</b-button>
                        <b-button class='cancel is-medium' @click="activeStep = 1">Previous</b-button>
                        
                        
                        <b-button class='cancel is-medium'  @click="resetState()">Start Over</b-button>
                        
                    </div>
                   
                    </b-step-item>

                    <b-step-item step="4" label="Finish!"  disabled>
                        <h1 class="title top-margin">Finish!</h1>
                        

                         <b-message id="success-msg" type="is-success" class="top-margin" v-if="submitSuccessMsg != ''">{{submitSuccessMsg}}</b-message>

                        <div class="top-margin" >
                            <b-button class='is-primary is-medium next' @click="resetState()">Add Another Post</b-button>
                            
                        </div>

                        <div class="link-to  top-margin box" style="text-align:center" v-if="submitSuccessMsg != ''">
                            <h3 class="title is-4" style="color:#f37d5e !important">Help more cyclists find BikeSleepBike!</h3>
                            <p>If you think this project is cool, the best way to help us grow is to <strong>link to bikesleepbike.com</strong> from your website. This helps other bike travelers find us and helps search engines see that we are real.</p>
                            <p>Thanks a bunch!  :)</p>
                            
                        </div>

                    </b-step-item>
                </b-steps>
                </div>


            
        
        <!-- <div class="section card top-margin">
            <div class="" >
                <p style="margin-bottom:10px;">The more the merrier! Share with your bicycle traveling friends:</p>
                <SocialSharePrompt v-bind:headerText="'Bike Sleep Bike'"/>
            </div>
        </div> -->
        </div>
        <div class="spacer" style="height:80px"></div>
    </div>  
</template>

<script>
import {continent_map, features} from "../data.js";
import CustomTagInput from '@/components/CustomTagInput';
import SocialSharePrompt from '@/components/SocialSharePrompt';

export default {
    name: 'AddTrip',
    components: {CustomTagInput, SocialSharePrompt},
    data () {
        return {
            url:"",
            pages:{},
            // countries:{},
            // allcountries:allcountries,
            allFeatures: features,
            countryRegions: [],
            routes: [],
            riderTags: [],
            approvedRoutes: [],
            approvedRiderTags: [],
            email: "",
            selectedSurfaces:[],
            selectedMoods: [],
            selectedStyles: [],
            selectedFeatures: [],
            selectedExtras: [],
            
            year: "",
            submitErrorMsg:"",
            errors:{"url":"", "selectedCountries":""},
            submitSuccessMsg: "",
          
            tempPageDoc:{},
            // gettingTempDetails:false,

            alreadyExists:false,
            editMode: false,
            existingPageData: {},

            // waitingForTempPageData: false,
            // foundPageStillWaiting: false,
            checkingPage: false,

            initDataLoaded: false,
            loadingMsg: "looking up...", 
            totals: {},
            

            activeStep: 0,
            steps: true,
            showInstructions: false,
            isMounted: false
            // allcountries:allcountries
            // us_states:us_states, // ADMIN only get these if needed
        }
    
    },
    watch: {
        // tempPageDoc() {
            // console.log("CHANGE");
            // console.log(this.tempPageDoc);
            // // if (this.tempPageDoc) {}
            // if (this.tempPageDoc && this.tempPageDoc.details_fetched !== undefined) {
            //     this.waitingForTempPageData = false;
            //     console.log("No more waiting");
            // }
            // if (this.tempPageDoc && this.tempPageDoc.added !== undefined && this.tempPageDoc.details_fetched === undefined) {
            //     this.foundPageStillWaiting = true;
            // } else {
            //     this.foundPageStillWaiting = false;
            // }
            
        // }
    },
    computed: {
        countryArray: function() {
            if (this.$countrymap) {
                var tosave = [];
                for (const prop in this.$countrymap) {
                    var elem = {code:prop, name:this.$countrymap[prop]};
                    tosave.push(elem);
                }
                return tosave;
            } else {
                return [];
            }
        },
        user: function() {
            return this.$getParent('App').user;
            // return this.$firebase.auth().currentUser;
        }
    },
    methods: {
        hideInstructions() {
            this.$cookies.set("bsb_add_instructions_closed", 1, 60*60*24*7*52);
            this.showInstructions = false;
            

        },
        toStep3() {
            // validate stuff
            if (this.getSelectedTags("country-tags").length > 0 && this.selectedStyles.length > 0) {
                this.activeStep = 2;
                this.submitErrorMsg = "";
                this.$scrollTo('#step-3-title');
                
            } else {
                var error = "";
                if (this.getSelectedTags("country-tags").length == 0) {
                    error =  error + "Please choose at least one country. ";
                }
                if (this.selectedStyles.length == 0) {
                    error = error + "Please choose at least one style.";
                }
               this.submitErrorMsg = error;
            }
            

        },
        pageInfo(prop) {
            if (this.alreadyExists && this.existingPageData[prop]) {
                return this.existingPageData[prop];
            } else if (this.tempPageData[prop]) {
                return this.tempPageData[prop];
            } else {
                return undefined;
            }
        },
        getSelectedTags(tagType) {
            return(this.$refs[tagType].selectedModel);
        },
        handleCountryChange() {
            var selectedCountries = this.getSelectedTags("country-tags");
            var countryCodes = [];
            selectedCountries.forEach(function(val, idx) {
                countryCodes.push(val.code);
            });
            this.getSubregions(countryCodes);
        },
        submitPage() {
            var selectedCountries = this.getSelectedTags("country-tags");
            var countryCodes = [];
            for (const idx in selectedCountries) {
                countryCodes.push(selectedCountries[idx]["code"]);
            }

            // console.log(countryCodes);
            if (this.isInputValid(this.url, countryCodes)) {

            // if (true) {
                // var cleanedUrl = this.url.split("?")[0];
                var cleanedUrl = this.cleanUrl(this.url);
                var encodedUrl = encodeURIComponent(cleanedUrl);
                // var regions = this.getSelectedTags("region-tags");
                var regions = this.$refs["region-tags"].selectedModel;

                var routeTags = this.getSelectedTags("route-tags");
                // var routeTags = this.$refs["route-tags"].selectedModel;
                var newRouteTags = this.$refs["route-tags"].newTags;
               
                // var existingRouteTags = this.$refs["route-tags"].computedExistingTags;
                var existingRouteTags = this.$refs["route-tags"].existingTags;
                console.log("existing route tags:", existingRouteTags);

                var ridertags = this.getSelectedTags("rider-tags");
                
                // var ridertags = this.$refs["rider-tags"].selectedModel;
                console.log("ridertags:",ridertags);
                var newRiderTags = this.$refs["rider-tags"].newTags;
                // var existingRiderTags = this.$refs["rider-tags"].existingTags;
                // var existingRiderTags = this.$refs["rider-tags"].computedExistingTags;
                var existingRiderTags = this.$refs["rider-tags"].existingTags;
                console.log("existing rider tags:", existingRiderTags);
                var match = continent_map.find(elem => elem["Two_Letter_Country_Code"] == countryCodes[0]);
                var continent = ""
                if (match) {
                    continent = match;
                }
                continent = match["Continent_Name"];

                var inputData = {
                    url:cleanedUrl, 
                    countries: countryCodes, 
                    regions: regions,
                    continent: continent,
                    routes: this.arrayUnique(existingRouteTags),
                    surfaces: this.selectedSurfaces,
                    mood: this.selectedMoods,
                    features: this.selectedFeatures,
                    ridertags: this.arrayUnique(existingRiderTags),
                    year: this.year,
                    submitted: true,
                    // added: new Date(), 
                    lastupdate: new Date(),
                    // image: this.tempPageDoc.image,

                };
                if (this.email != "") {
                    inputData.email = this.email;
                }
                if (this.selectedStyles.includes("bikepacking")) {
                    inputData['bikepacking'] = true;
                }
                if (this.selectedStyles.includes("touring")) {
                    inputData['touring'] = true;
                }
                if (this.selectedExtras.includes('map')) {
                     inputData['map'] = true;
                }
                if (this.selectedExtras.includes('video')) {
                     inputData['video'] = true;
                }
                if (this.selectedExtras.includes('short')) {
                     inputData['short'] = true;
                }
                if (this.selectedExtras.includes('podcast')) {
                     inputData['podcast'] = true;
                }
                if (this.$isAdmin()) {
                    inputData['added_by'] = "admin";
                }

                console.log("data to save: ");
                console.log(inputData);
                if (!this.editMode) {
                    inputData.added = new Date();
                } else if (this.editMode) {
                    inputData.previous = this.existingPageData;
                    inputData['is_edit'] = true;
                    inputData['last_edited_on'] = new Date();
                }
                // console.log(inputData);
                // console.log(this.tempPageDoc);

                // var fields = {...inputData, ...this.tempPageDoc};
                var fields = {...this.tempPageDoc, ...inputData};
                console.log("About to save page. Isedit= ", inputData.is_edit);
                console.log("Temppagedoc: ");
                console.log(this.tempPageDoc);
                console.log("input data:");
                console.log(inputData);
                console.log("Combined: ");
                console.log(fields);
                console.log("existing page data:");
                console.log(this.existingPageData);
                var that = this;
                this.$db.collection("pages_unapproved").doc(encodedUrl).set(fields, { merge: true })
                    .then(function() {
                        // SUCCESSFUL NEW PAGE SUBMIT
                        // Clean up state to be ready for new submission
                        that.url = "";
                        that.gettingTempDetails = false;
                        that.resetState();
                        that.url = "";
                        that.submitSuccessMsg = "Thanks! If approved your entry will be added to the directory. In the meantime, feel free to submit another.";
                        if (that.steps) {that.activeStep = 3};
                        var that2 = that;
                        setTimeout(function() {that2.$scrollTo("#success-msg", 500);}, 200);
                        that.$scrollTo("#success-msg", 500);
                        that.submitErrorMsg = "";

                        // ADD NEW TAGS (IF ANY) TO APPROVAL QUEUE and cookie locally
                        newRiderTags.forEach(function(tag) {
                            that.$db.collection("tags_unapproved").add({
                                tag: tag.trim(),
                                tagtype: "ridertags",
                                pageid: encodedUrl
                            })
                            .then(function(docRef) {
                                // console.log("added tag to approval queue with ID: ", docRef.id);
                                // add to local cookie if not already there
                                // var riderTagsCookieStr;
                                that.updateCookies("ridertags", tag.trim());
                                if (!that.riderTags.includes(tag.trim())) {
                                    that.riderTags.push(tag.trim());
                                }
                            })
                            .catch(function(error) {
                                console.error("Error adding tag to approval queue: ", error);
                            });
                        });
                        newRouteTags.forEach(function(tag) {
                            that.$db.collection("tags_unapproved").add({
                                tag: tag.trim(),
                                tagtype: "routes",
                                pageid: encodedUrl,
                                continent: continent,
                                countries: countryCodes
                            })
                            .then(function(docRef) {
                                that.updateCookies("routes", tag.trim());
                                // that.routes.push(tag.trim());
                                if (!that.routes.includes(tag.trim())) {
                                    that.routes.push(tag.trim());
                                }
                                // console.log("added tag to approval queue with ID: ", docRef.id);
                            })
                            .catch(function(error) {
                                console.error("Error adding tag to approval queue: ", error);
                            });
                        });
                    })
                    .catch(function(error) {
                        console.error("Error writing document: ", error);
                    });

                

            } else {
                this.submitErrorMsg = "Please fix: " + this.errors.url + " " + this.errors.selectedCountries;
            }
          
        },
        updateCookies(tagtype, tag) {
            var cookieName = "tag_" + tagtype;
            var cookieStr;
            var cookieArr;
            if ($cookies.isKey(cookieName)) {
                cookieStr = $cookies.get(cookieName);
                console.log(cookieStr);
                cookieArr = JSON.parse(cookieStr);
                console.log(cookieArr);
                if (!cookieArr.includes(tag)) {
                    cookieArr.push(tag);
                    cookieStr = JSON.stringify(cookieArr);
                    $cookies.set(cookieName, cookieStr);
                }
            } else {
                cookieArr = [ tag ];
                cookieStr = JSON.stringify(cookieArr);
                $cookies.set(cookieName, cookieStr);
            }
        },
        cleanUrl(url) {
            var parts = url.split("?");
            var cleanedUrl = "";
            if (parts.length > 1 && parts[1].includes("lang=")) { // only allow language param for now
                cleanedUrl = this.url;
            } else if (parts.length > 1 && parts[0].includes("youtube.com/watch") && parts[1].includes("v=")) {
                cleanedUrl = this.url;
            } else {
                cleanedUrl = this.url.split("?")[0];
            }
            return cleanedUrl;
        },
        checkPage() {
            // Reset some things
            // this.resetState();
            // console.log("Checking for page ", this.url);
            this.submitErrorMsg = "";
            this.errors = {"url":"", "selectedCountries":""};
            this.submitSuccessMsg = "";
            this.gettingTempDetails = false;

            if (this.isValidUrl(this.url)) {
                // console.log("getting page data");
                this.checkingPage = true;
                // 
                var cleanedUrl = this.cleanUrl(this.url);
                var encodedURL = encodeURIComponent(cleanedUrl);
                // console.log("looking for ", cleanedUrl);
                //CHECK IF PAGE IS ALREADY IN PAGES
                var that = this;
                // this.$db.collection("pages").where("url", "==", cleanedUrl).get().then(function(doc) {
                this.$db.collection("pages").doc(encodedURL).get().then(function(doc) {
                    // console.log("Checking if already exists " + encodedURL);
                    if (doc.exists) {  // this will be an edit if the user goes ahead
                        console.log("Already exists");
                        that.alreadyExists = true;
                        console.log("Document data:", doc.data());
                        that.existingPageData = doc.data();
                        that.checkingPage = false;
                    } else {  // we're adding a new page and fetching stuff in the background
                         //Add to pages_temp
                        var tempPageData = {docid: encodedURL, url: cleanedUrl, merge:true};
                        var addTempPage = that.$firebase.functions().httpsCallable('addTempPage');
                        // var that2=that;
                        if (that.steps) { that.activeStep = 1; }

                        addTempPage(tempPageData).then(function(resultData) {
                            that.$fetchDoc("pages_unapproved", resultData.data.id, "tempPageDoc");
                            
                        });
                    }
                }).catch(function(error) {
                    console.log("Error checking to see if page exists: ", error);
                });

            } else {
                this.submitErrorMsg = "Errors: " + this.errors.url + " " + this.errors.selectedCountries;
            }
        },
        editExisting() {
            // this.tempPageDoc = this.existingPageData;
            if (this.$debug) {
                console.log("DEBUG: In function editExisting")
                console.log(this.existingPageData);
            };
            
            this.editMode = true;
            if (this.existingPageData.surfaces) {
                this.selectedSurfaces = this.existingPageData.surfaces;
            }
            if (this.existingPageData.mood) {
                this.selectedMoods = this.existingPageData.mood;
            }
            if (this.existingPageData.features) {
                this.selectedFeatures = this.existingPageData.features;
            }
            if (this.existingPageData.touring) {
                this.selectedStyles.push("touring");
            }
            if (this.existingPageData.bikepacking) {
                this.selectedStyles.push("bikepacking");
            }
            if (this.existingPageData.map) {
                this.selectedExtras.push("map");
            }
            if (this.existingPageData.video) {
                this.selectedExtras.push("video");
            }
            if (this.existingPageData.short) {
                this.selectedExtras.push("short");
            }
            if (this.existingPageData.podcast) {
                this.selectedExtras.push("podcast");
            }
            if (this.existingPageData.year) {
                this.year = this.existingPageData.year;
            }
            var that = this;
            if (this.existingPageData.countries) {
                var countryObjs = [];
                this.existingPageData.countries.forEach(function(val, idx) {
                    countryObjs.push({ name: that.$countrymap[val], code: val });
                });
                this.$refs["country-tags"].selectedModel = countryObjs;
                this.handleCountryChange();
            }
            
            if (this.existingPageData.regions) {
                this.$refs["region-tags"].selectedModel = this.existingPageData.regions;
            }
            if (this.existingPageData.routes) {
                this.$refs["route-tags"].selectedModel = this.existingPageData.routes;
            }
            if (this.existingPageData.ridertags) {
                this.$refs["rider-tags"].selectedModel = this.existingPageData.ridertags;
            }

            // TODO add other tags etc here 
            this.activeStep = 1;

        },
        resetState() {
            if (this.$refs["country-tags"]) {
                this.$refs["country-tags"].selectedModel = [];
            }
            if (this.$refs["region-tags"]) {
                this.$refs["region-tags"].selectedModel = [];
            }
            if (this.$refs["route-tags"]) {
                this.$refs["route-tags"].selectedModel = [];
                this.$refs["route-tags"].newTags = [];
                this.$refs["route-tags"].existingTags = [];
            }
            if (this.$refs["rider-tags"]) {
                this.$refs["rider-tags"].selectedModel = [];
                this.$refs["rider-tags"].newTags = [];
                this.$refs["rider-tags"].existingTags = [];
            }
            this.selectedSurfaces = [];
            this.selectedMoods = [];
            this.selectedStyles = [];
            this.selectedExtras = [];
            this.selectedFeatures = [];
            this.countryRegions = [];
            this.year = "";
            this.tempPageDoc = {};
            this.existingPageData = {};
            this.alreadyExists = false;
            this.editMode = false;
            this.checkingPage = false;
            this.activeStep = 0;
            this.url = "";
            this.submitErrorMsg = "";
            
        },
        isInputValid(url, countryCodes) {
            var isValid = true;
            if (!this.isValidUrl(url)) {
                // this.errors.url = "Enter a valid URL."
                isValid = false;
            }
            if (countryCodes.length == 0) {
                this.errors.selectedCountries = "Choose at least one country.";
                isValid = false;
            }
            return isValid;
            
        },
        isValidUrl(text) {
            var pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
            // var pattern = new RegExp('/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi');
            // console.log(pattern.test(this.url));

            //TODO: check to make sure it's a single blog post, not a root
            // var isValid = false;
            if (pattern.test(text)) {
                // console.log("Passed pattern check: " + text);
                // console.log("Passed regex");
                // return true;
                if (text.split("/").length - 1 == 2 || (text.split("/").length - 1 == 3 && text[text.length - 1] == "/")) { //text[text.length - 1] == "/" || 
                    // console.log("Failed");
                    this.errors.url = "Oops, that looks like a home page. Please enter the URL of a specific trip journal."
                    // console.log("Failed home page check");
                    return false;
                } else {
                    // console.log("passed");
                    return true;
                }

            } else {
                this.errors.url = "Enter a valid URL."
                // console.log("Failed pattern check");
                return false;
            }
            // return pattern.test(text);        
        },
        // removeExtraSubregions() {

        // },
        getSubregions(countryCodes) {
            if (countryCodes == undefined || countryCodes.length == 0) {
                this.countryRegions = [];
                this.$refs["region-tags"].selectedModel = [];
            } else if (countryCodes.length <= 10) {
                var that = this;
                var updatedCountryRegions = [];
                this.$db.collection("regions").where("country", "in", countryCodes).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, " => ", doc.data());
                            // console.log(that[outname]);
                            // that[outname].push(doc.data());
                            updatedCountryRegions.push(...doc.data().regions);
                            // TODO: make sure selectedModel for regions is a subset of this.countryRegions after every change (remove subregions from removed countries)
           
                        });
                        that.countryRegions = updatedCountryRegions;
                        // var that = this;
                        that.$refs["region-tags"].selectedModel.forEach(function(val, idx) {
                            if (!that.countryRegions.includes(val)) {
                                that.$refs["region-tags"].selectedModel.splice(idx, 1);
                            }
                        });
                    }).catch(function(error) {
                            console.error("Error finding subregions: ", error);
                    });
            }
        },
        loadData() {
            var loadedAll = true;
            if (!this.initDataLoaded) {
                var that = this;

                // ROUTE TAGS
                var dbRoutes = [];
                that.$db.collection("tags").doc("routes").get()
                    .then(function(doc) {
                        if (doc.exists){
                            dbRoutes = doc.data().routes;
                            var cookieRoutes = that.getCookieArray("routes");
                            // console.log(cookieRoutes);
                            that.routes = that.arrayUnique( [...dbRoutes, ...cookieRoutes] );
                            that.approvedRoutes = dbRoutes;
                        }
                    
                    }).catch(function(error) {
                        console.error("Error finding routes: ", error);
                        loadedAll = false;
                    });
                // add any local routes from cookies
                // var cookieName = "routes";
                
                


                // RIDERTAGS
                var dbRiderTags = [];
                that.$db.collection("tags").doc("ridertags").get()
                    .then(function(doc) {
                        if (doc.exists){
                            dbRiderTags = doc.data().ridertags;
                            var cookieRiderTags = that.getCookieArray("ridertags");
                            // console.log(cookieRiderTags);
                            that.riderTags = that.arrayUnique( [...dbRiderTags, ...cookieRiderTags] );
                            that.approvedRiderTags = dbRiderTags;

                            // that.riderTags = doc.data().ridertags;
                        }
                    
                    }).catch(function(error) {
                            console.error("Error finding rider tags: ", error);
                            loadedAll = false;
                    });

                    // STATS
                    // var that = this;
                    that.$db.collection("counts").doc("totals").get()
                        .then(function(doc) {
                            
                            if (doc.exists){
                                console.log(doc.data());
                                that.totals = doc.data();
                            }
                        
                        }).catch(function(error) {
                            console.error("Error fetching totals: ", error);
                        });
            }
            if (loadedAll) {
                this.initDataLoaded = true;
            }
        },
        getCookieArray(tagtype) {
            var cookieName = "tag_" + tagtype;
            // console.log("COOOOKIES");
            var cookieArr = [];
            if ($cookies.isKey(cookieName)) {
                var cookieStr = $cookies.get(cookieName);
                // console.log(cookieStr);
                cookieArr = JSON.parse(cookieStr);
            }
            return cookieArr;
        },
        signOut() {
            this.$firebase.auth().signOut().then(function() {
            // Sign-out successful.
                location.reload();
            }).catch(function(error) {
            // An error happened.
            });
        },
        arrayUnique(array) {
            var a = array.concat();
            for(var i=0; i<a.length; ++i) {
                for(var j=i+1; j<a.length; ++j) {
                    if(a[i] === a[j])
                        a.splice(j--, 1);
                }
            }

            return a;
        }
    },
    mounted() {
        // console.log("Checking if current user: ");

        // this.$refs.urlinput.focus();
        if (!this.$cookies.get("bsb_add_instructions_closed")) {
            this.showInstructions = true;
        }


        var that = this;
        if (!that.isMounted && that.$getParent('App').user) {
            that.loadData();
            that.isMounted = true;
        }

        this.$firebase.auth().onAuthStateChanged(function(user) {
            if (!that.isMounted && user) {
                that.loadData();
                that.isMounted = true;
            }
        });



        // // var user = this.$firebase.auth().currentUser;
        // if (!this.$getParent('App').user) {
        //     this.$firebase.auth().signInAnonymously().then(function() {
        //         that.loadData();
        //         console.log("User is authed as ", this.$firebase.auth().currentUser);
        //     })
        //     // User is signed in.
        // } 
              

        // // console.log("Signing in");
        // console.log(this.$firebase.auth().currentUser);
        // var that = this;

        // this.$firebase.auth().onAuthStateChanged(function(user) {
        //     if (!user) {
        //         this.$firebase.auth().signInAnonymously().then(function() {
        //             that.loadData();
        //             console.log("User is authed as ", this.$firebase.auth().currentUser);
        //         })
        //         // User is signed in.
        //     } else {
        //         that.loadData();
        //         console.log("there's already a user");
        //     }
        // });


        // ADMIN IMPORTS
        // this.$writeDoc("regions","US",{regions: this.us_states}, false); // also uncomment us_states in data
    },
    metaInfo() {
        var title = 'Submit Bike Travel Blog Posts | BikeSleepBike';
        var description = "Add bike touring and bikepacking blogs to the BikeSleepBike directory.";
        return {
            title: title,
            description: description,
            // title: title,
            titleTemplate: '%s | BikeSleepBike',
            // description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "description", content: description  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            
        }
    }
}
</script>
   
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .step span.step-number {
        background: #2763a1 ;
        border-radius: 0.8em;
        -moz-border-radius: 0.8em;
        -webkit-border-radius: 0.8em;
        color: #ffffff;
        display: inline-block;
        font-size: 25px;
        font-weight: bold;
        line-height: 1.6em;
        margin-right: 5px;
        text-align: center;
        width: 1.6em; 
        margin-bottom: 10px;
    }
    .step p, .step-text {
        /* color: #2763a1; */
        font-size: 18px;
        line-height: 24px;
        color: black;
    }


    .link-to {
        box-shadow:none;
    }
    .new-page-form .steps {
        padding:40px; 
        margin-top:30px; 
        background-color:white
    }
     @media screen and (max-width: 789px) {
         .new-page-form .steps {
             padding: 20px 10px;
         }
     }
     .new-page-form {
        text-align:left;
        
    }
    /* .taginput.wrap {
        display:block;
    }
    .taginput.wrap .control {
        display:inline-block;
        margin-right:3px; 
        margin-bottom: 5px;
    }
    .taginput.wrap .control .button {
        border-radius: 0px !important;
    } */
    .submit-btn {
        /* margin-top: 30px;; */
    }
    .tooltip-trigger,
    .tooltip-trigger:hover,
    .tooltip-trigger:active,
    .tooltip-trigger:focus {
        background-color: transparent;
    }
    .tooltip-icon {
        color:#a4a4a4;
    }
    
    .combined-error {
        /* margin-top:30px; */
    }
    /* .top-margin {
        margin-top:40px;
    } */
    .input-page-details {
        /* padding:30px; */
        /* margin-top:50px; */
    }
    .hidden {
        display:none;
    }
    .year-input {
        width:150px;
    }
    .find-trips, .add-trips {
    /* max-width:1000px; */
  }
   html {
    background-color: #fafafa;
  }
    .submit-nav-buttons {
        display:block;
        margin-top:35px;
        padding-top: 35px;
        border-top: 2px solid #ebe6e6;
    }
  
    .hide-instructions {
        cursor: pointer;
    }
</style>

<style>

    .b-steps .steps .step-items .step-item.is-primary.is-active .step-marker {
      background-color: #2763a1 !important;
      color: white !important;
      border-color: #2763a1 !important;
  }
  .b-steps .steps .step-items .step-item.is-primary.is-previous .step-marker {
      background-color: white !important;
      color:  #2763a1 !important;
      border-color: #2763a1 !important;
  }
    li.step-item.is-primary.is-active::before,
    li.step-item.is-primary.is-previous::before {
        background: #2763a1 !important;
    }

</style>







// WEBPACK FOOTER //
// src/components/AddTrip.vue